import * as React from "react";

import { cn } from "@/lib/utils";

type TSkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Reusable pulse skeleton for ghost loading states.
 * Use with className for width/height (e.g. h-4 w-full, h-20 rounded-lg).
 */
export function Skeleton({ className, ...props }: TSkeletonProps) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted-foreground/15 dark:bg-muted-foreground/10", className)}
      {...props}
    />
  );
}
